import { render, staticRenderFns } from "./GroupDataTable.vue?vue&type=template&id=1b6ee870&scoped=true&"
import script from "./GroupDataTable.vue?vue&type=script&lang=js&"
export * from "./GroupDataTable.vue?vue&type=script&lang=js&"
import style0 from "./GroupDataTable.vue?vue&type=style&index=0&id=1b6ee870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6ee870",
  null
  
)

export default component.exports